"use strict";

var _interopRequireDefault = require("reshow-runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _getoffset = _interopRequireDefault(require("getoffset"));
var _isFixed = _interopRequireDefault(require("./isFixed.js"));
var _isSetOverflow = _interopRequireDefault(require("./isSetOverflow.js"));
var _type = require("./type.js");
// @ts-check

/**
 * @param {HTMLElement} dom
 * @returns {DomPositionInfoType}
 */
var getDomPositionInfo = function getDomPositionInfo(dom) {
  var fixedNode = (0, _isFixed["default"])(dom);
  var overflowNode = (0, _isSetOverflow["default"])(dom);
  var domScroller = /** @type HTMLElement */fixedNode || overflowNode;
  var domOverflowInfo = /** @type DomInfoType*/(0, _getoffset["default"])(dom, domScroller);
  domOverflowInfo.domScroller = domScroller;
  domOverflowInfo.fixedNode = domScroller;
  domOverflowInfo.overflowNode = domScroller;
  var domInfo = /** @type DomInfoType*/(0, _getoffset["default"])(dom);
  return {
    domInfo: domInfo,
    domOverflowInfo: domOverflowInfo,
    fixedNode: fixedNode,
    overflowNode: overflowNode
  };
};
var _default = exports["default"] = getDomPositionInfo;
module.exports = exports.default;